import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useLocalStorage} from 'react-use';
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Container,
    Form,
    Row,
    Modal,
  } from 'react-bootstrap';

import {
    Grid,
    PagingPanel,
    Table,
    TableHeaderRow,
    TableColumnResizing,
    SearchPanel,
    Toolbar,
  } from '@devexpress/dx-react-grid-bootstrap4';

import { Loading } from '../../components/Loading/loading.js';

// react component used to create alerts
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';

const rows = [
  {
    "FILE_ID": 1,
    "FILE_NAME": "SK Auditor",
    "FILE_LINK": "https://multimedianusantara-my.sharepoint.com/:f:/g/personal/bpmi_umn_ac_id/EhyVNJMGD-hHoVIms_v5-IMB-2j_-4KxPJh2fReiIN0J3g?e=fq8qkJ"
  },
  {
    "FILE_ID": 2,
    "FILE_NAME": "Materi Pelatihan Auditor /Auditee",
    "FILE_LINK": "https://multimedianusantara-my.sharepoint.com/:f:/g/personal/bpmi_umn_ac_id/EnEtpDAnnNRJkXU1xzeN7PsBW79BY8ffSt2znOVy_erAtw?e=4KdANW"
  },
  {
    "FILE_ID": 3,
    "FILE_NAME": "Panduan/Matriks Akreditasi",
    "FILE_LINK": "https://multimedianusantara-my.sharepoint.com/:f:/g/personal/bpmi_umn_ac_id/EoLgK5MYS99CqXwC1Cla9M0BNucNw3GKAoTvSjjBD4gzwQ?e=T9aAzE"
  },
  {
    "FILE_ID": 4,
    "FILE_NAME": "Timeline Audit Mutu Internal",
    "FILE_LINK": "https://multimedianusantara-my.sharepoint.com/:f:/g/personal/bpmi_umn_ac_id/EjQYS5bPT39IsHai-V6EuZcBMlu_sNTO5GQBEv3FpK87NA?e=77rffb"
  },
  {
    "FILE_ID": 5,
    "FILE_NAME": "Laporan Audit Mutu Internal",
    "FILE_LINK": "https://multimedianusantara-my.sharepoint.com/:f:/g/personal/bpmi_umn_ac_id/EhG3oBQZ66tJgbK9Svi8hgsBNcvIqZDrOLlWwxEEavpZNg?e=4glqY1"
  },
];

export default function Document() {

  const [swal, setSwal] = useAlert();
  const [auth] = useLocalStorage('authenticated');
  const [defaultColumnWidths] = useState([
    { columnName: 'FILE_ID', width: 150 },
    { columnName: 'FILE_NAME', width: 550 },
    { columnName: 'FILE_LINK', width: 200 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);
  const [modalShow, setModalShow] = useState(false);
  const [linkFile, setLinkFile] = useState(false);

  const getRowId = row => row.FILE_ID;

  const columns = [
    { name: 'FILE_ID', title: 'ID' },
    { name: 'FILE_NAME', title: 'NAME' },
    // { name: 'FILE_LINK', title: 'ACTION', getCellValue: (row) => <Button onClick={() => handleOpenInfo(row)} variant="info" size="sm">Open</Button>},
    { name: 'FILE_LINK', title: 'ACTION', getCellValue: (row) => <Button href={`${row.FILE_LINK}`} target="_blank" variant="info" size="sm">Open</Button>},
  ];

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <p>Baca dan pahami peringatan pengisian LKPS berikut sebelum mengunduhnya :</p>
          <ol>
            <li>Tidak diperbolehkan mengubah / menghapus struktur tabel yang tersedia dan mewarnai cell/sheet tabs pada LKPS.</li>
            <li>Cell yang tidak diisi agar dikosongkan saja. Mohon tidak mengisi dengan tanda "-" atau tanda lain semisalnya. Isi cell yang berwarna KUNING saja.</li>
            <li>Untuk menambahkan cell baru, sisipkan di kolom area sel berwarna kuning agar perhitungan tetap akurat.</li>
            <li>Pengisian excel LKPS agar menggunakan Microsoft Excel (Asli dari Microsoft) bukan menggunakan software-software sejenis seperti Zoho Sheet, OpenOffice, WPS Office Spreadsheets dan sebagainya karena penggunaan software selain microsoft excel dapat menimbulkan error pada file LKPS yang diisi.</li>
            <li>Bila ada pertanyaan lebih lanjut, hubungi BPMI.</li>
          </ol>
        </Modal.Body>
        <Modal.Footer>
          <Button href={linkFile} onClick={props.onHide} target="_blank">Mengerti</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function handleOpenInfo(row){
    setModalShow(true)
    setLinkFile(row.FILE_LINK)
  }

  return (
    <>
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Document
          </Breadcrumb.Item>
        </Breadcrumb>

        {rows && (
          <Row>
            <Col md="12">
              <Card className='center'>
                <Card.Header className="text-center">
                  <Card.Title as="h4">List of BPMI Documents</Card.Title>
                </Card.Header>
                <Card.Body>
                  <MyVerticallyCenteredModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                  />
                  <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}
                  >
                    <Table />
                    <TableColumnResizing
                      columnWidths={columnWidths}
                      onColumnWidthsChange={setColumnWidths}
                    />
                    <TableHeaderRow />
                    <Toolbar />
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}